import { sweetalert } from "../App";
import { ServerResponse } from "../types/ServerResponse";

// Opens a PDF returned by NetworkUtil.makePostForBuffer in a new tab. Error responses come back as a
// ServerResponse instead of a Blob; show the reason rather than throwing so callers can clear their spinner.
export const openPDFInNewTab = async (report: Blob | ServerResponse): Promise<boolean> => {
    if (!(report instanceof Blob)) {
        console.error("PDF request failed", report);
        sweetalert.fire({ icon: "error", title: "", text: report?.reason || "Error opening report for viewing" });
        return false;
    }
    const data = await report.arrayBuffer();
    const blob = new Blob([data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
    return true;
}
